'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Faq(eyebrow, title, lead, items) {
  this.ha = null;
  this.hd = null;
  this.hc = null;
  this.hb = null;
  this.ha = eyebrow;
  this.hd = title;
  this.hc = lead;
  this.hb = items;
}
export { $c_Lio_intela_sites_intelacloud_content_Faq as $c_Lio_intela_sites_intelacloud_content_Faq };
$p = $c_Lio_intela_sites_intelacloud_content_Faq.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Faq;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Faq() {
}
export { $h_Lio_intela_sites_intelacloud_content_Faq as $h_Lio_intela_sites_intelacloud_content_Faq };
$h_Lio_intela_sites_intelacloud_content_Faq.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, 136536441, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Faq)) {
    if ((this.ha === x$0.ha)) {
      var x = this.hd;
      var x$2 = x$0.hd;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.hc === x$0.hc))) {
      var x$3 = this.hb;
      var x$4 = x$0.hb;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 4;
});
$p.I = (function() {
  return "Faq";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.ha;
      break;
    }
    case 1: {
      return this.hd;
      break;
    }
    case 2: {
      return this.hc;
      break;
    }
    case 3: {
      return this.hb;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Faq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bt)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Faq as $isArrayOf_Lio_intela_sites_intelacloud_content_Faq };
var $d_Lio_intela_sites_intelacloud_content_Faq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Faq, "io.intela.sites.intelacloud.content.Faq", ({
  bt: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Faq as $d_Lio_intela_sites_intelacloud_content_Faq };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Faq.js.map
